import { Text, LinkButton } from '$components'
import { AuthRoutePath } from '../routes/public'

export function ResetPasswordConfirmationPage() {
  return (
    <div className="flex items-center justify-center h-screen w-full">
      <div className="space-y-stack-roomy max-w-prose-sm">
        <Text type="h1">
          Password reset successful!
        </Text>

        <Text className="text-fg-subtle">
          Your password has been reset successfully. You can now log in using your new password.
        </Text>

        <LinkButton
          to={AuthRoutePath.Login}
          variant="secondary"
          size="lg"
        >
          Login
        </LinkButton>
      </div>
    </div>
  )
}
